import { render } from "./Loader.vue?vue&type=template&id=021afb23"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=021afb23&lang=css"

import exportComponent from "D:\\Work\\Vizion\\transfer-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__